import React from "react";
import { 
   Drawer, 
   Button, 
   Result 
} from "antd";
import { CloudDownloadOutlined } from "@ant-design/icons";
import { exportDatabseFile } from "services/db";
import { Util } from "common/util";

export default function BackupRestore() {
   return Util.getInstance().hasPermission("backup database", "setting") ? 
      <Result
         icon={<CloudDownloadOutlined />}
         status="warning"
         title="Backup Database"
         subTitle="You can backup database with the following option and keep in secure place."
         extra={[
            <Backup />
         ]}
      />
      :
      <Result
         status="403"
         title="403"
         subTitle="Sorry, you are not authorized to access this backup page."
      />
      ;
}

function Backup() {
   const [visible, setVisible] = React.useState(false);

   return <>
      <Button type="primary" key="console" onClick={() => setVisible(true)}>
         Backup Database
      </Button>
      <Drawer
         title="Database Backup"
         placement="right"
         closable={true}
         onClose={() => setVisible(false)}
         visible={visible}
      >
         {visible ? <BackupLoader /> : null}
      </Drawer>
   </>
}

function BackupLoader() {
   const [downloadUrl, setDownloadUrl] = React.useState("");
   React.useEffect(() => {
      exportDatabseFile()
      .then(responseUrl => {
         setDownloadUrl(responseUrl);
      });
      // eslint-disable-next-line
   },[]);

   return <Result
      status="success"
      title="Database backup completed successfully!"
      extra={[
      <div style={{ marginBottom: 25 }}>
         <a key="1" className="ant-btn ant-btn-dashed" href={downloadUrl}>
            Download File(sql)
         </a>
      </div>
      ]}
   />;
}